import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Elementui from 'element-ui'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import tool from "./utils/tool";


Vue.use(tool);

Vue.config.productionTip = false

Vue.prototype.$http = axios;
Vue.prototype.$layer = layer(Vue);
Vue.use(Elementui)

//图片域名
Vue.prototype.$uploadUrl = 'http://admin.sjzd1879.com/uploads/';

//统一接口域名
if(window.location.host == 'localhost:8080'){
  axios.defaults.baseURL='http://admin.sjzd1879.com/api/';
}else{
  axios.defaults.baseURL='http://admin.sjzd1879.com/api/';
}

axios.interceptors.response.use(
  response => {
    //当返回信息为未登录或者登录失效的时候重定向为登录页面
    if (response.data.code == 401 || response.data.code == 403 || response.data.code == 404 || response.data.code == 405 || response.data.code == '登录超时请重新登录' || response.data.code == 'Token无效' ) {
      Elementui.Message({
          message: '登录失效，请重新登录',
          type: 'warning',
          duration:'1500',
          center: true
        });

        setTimeout(() => {
          router.push({
            path: "/login",
            querry: { redirect: router.currentRoute.fullPath }//从哪个页面跳转
          })
        }, 1500);
        
    }
    return response;
  },
  error => {
    // return Promise.reject(error)
  }
)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
